module.exports = __webpack_public_path__ + "img/no_coupon.23af3d7f.png";